import React from 'react';
import {
  ReferenceManyField,
  Datagrid,
  TextField,
  FunctionField,
  ReferenceField,
  DateField,
  useShowController,
  useRedirect
} from 'react-admin';
import { Box, Paper, Typography, Chip } from '@mui/material';

import EmptyState from '../EmptyState';
import useStyles from './styles';
import { formatDateTime } from '../../utils/timeFormat';

const SubscriptionsTab = props => {
  const { record } = useShowController(props);
  const classes = useStyles();
  const redirect = useRedirect();
  if (!record) return null;

  const createRowClickHandler = (resource) => () => {
    const filter = JSON.stringify({ userId: record.id });
    redirect(`/${resource}?filter=${encodeURIComponent(filter)}`);
  };

  return (
    <Box>
      <Paper className={classes.subscriptionCard} elevation={1}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Subscription захиалгууд
        </Typography>
        <ReferenceManyField
          reference="userSubscriptions"
          target="userId"
          sort={{ field: 'createdAt', order: 'DESC' }}
        >
          <Datagrid rowClick={createRowClickHandler('userSubscriptions')}>
            <TextField source="id" label="ID" />
            <TextField source="status" label="Захиалгын статус" />
            <FunctionField label="Захиалга хийгдсэн огноо" render={record => formatDateTime(record.createdAt)} />
            <FunctionField label="Эхлэх огноо" render={record => formatDateTime(record.startDate)} />
            <FunctionField label="Дуусах огноо" render={record => formatDateTime(record.endDate)} />
          </Datagrid>
        </ReferenceManyField>
      </Paper>

      <Paper className={classes.subscriptionCard} elevation={1}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Carrier Billing захиалгууд
        </Typography>
        <ReferenceManyField
          reference="carrierBillingSubscriptions"
          target="userId"
          sort={{ field: 'createdAt', order: 'DESC' }}
          empty={<EmptyState message="Carrier Billing захиалга байхгүй байна" />}
        >
          <Datagrid rowClick={createRowClickHandler('carrierBillingSubscriptions')}>
            <TextField source="id" label="ID" />
            <TextField source="referenceId" label="Reference ID" />
            <TextField source="msisdn" label="Утасны дугаар" />
            <TextField source="packageId" label="Package ID" />
            <TextField source="recurringPeriod" label="Төрөл" />
            <TextField source="status" label="Төлөв" />
            <TextField source="createdAt" label="Үүсгэсэн огноо" showTime />
            <DateField source="expiredAt" label="Дуусах огноо" showTime />
          </Datagrid>
        </ReferenceManyField>
      </Paper>

      <Paper className={classes.subscriptionCard} elevation={1}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Хөтөлбөрийн захиалгууд
        </Typography>
        <ReferenceManyField
          reference="purchaseOrders/lingo/journeys"
          target="userId"
          sort={{ field: 'createdAt', order: 'DESC' }}
          empty={<EmptyState message="Хөтөлбөрийн захиалга байхгүй байна" />}
        >
          <Datagrid rowClick={createRowClickHandler('purchaseOrders/lingo/journeys')}>
            <TextField source="id" label="ID" />
            <ReferenceField label="Хөтөлбөр" source="items.0.productId" reference="lingo/journeys">
              <TextField source="title" />
            </ReferenceField>
            <TextField source="status" label="Төлөв" />
            <FunctionField
              label="Төлбөр"
              render={record => record.items[0]?.amount ?
                new Intl.NumberFormat('mn-MN', {
                  style: 'currency',
                  currency: 'MNT',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(record.items[0].amount) : '-'}
            />
            <FunctionField label="Захиалга хийгдсэн огноо" render={record => formatDateTime(record.createdAt)} />
          </Datagrid>
        </ReferenceManyField>
      </Paper>

      <Paper className={classes.subscriptionCard} elevation={1}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Free Trial мэдээлэл
        </Typography>
        <ReferenceManyField
          reference="freeTrials"
          target="userId"
          sort={{ field: 'createdAt', order: 'DESC' }}
          empty={<EmptyState message="Free Trial мэдээлэл байхгүй байна" />}
        >
          <Datagrid className={classes.freeTrialTable}>
            <TextField source="id" label="ID" />
            <TextField source="plan.description" label="Төлөвлөгөөний нэр" />
            <FunctionField
              label="Төлөв"
              render={record => {
                const isExpired = record.expired;
                const displayText = isExpired ? 'Хугацаа дууссан' : 'Идэвхтэй';
                const chipClass = isExpired ? classes.expiredStatus : classes.activeStatus;
                return <Chip label={displayText} size="small" className={chipClass} />;
              }}
            />
            <FunctionField label="Эхэлсэн огноо" render={record => formatDateTime(record.startAt)} />
            <FunctionField label="Дуусах огноо" render={record => formatDateTime(record.expireAt)} />
          </Datagrid>
        </ReferenceManyField>
      </Paper>
    </Box>
  );
};

export default SubscriptionsTab; 